import React, { useEffect, useState } from "react";
import { Tree } from "@gw/web-basic-components";
import { walkTree } from "@gw/gw-utils";
import { ItemMenu, MenuIcon } from "./components";
import type { TreeProps } from "rc-tree";
import type { TreeDataNode } from "@gw/web-basic-components";
import type { GWTreeProps } from "./dto";

import FolderIcon from "./assets/icon-folder.svg";
import FileIcon from "./assets/icon-file.svg";
/**
 * 业务组件 树
 * @deprecated 1.x版本组件，不再维护，请尽快迁移至本地项目
 */
export default function GWTree({
  children,
  selectAll,
  expandAll,
  titleField,
  ...rest
}: GWTreeProps) {
  const [checkedKeys, setCheckedKeys] = useState<TreeProps["checkedKeys"]>([]);
  const [expandedKeys, setExpendedKeys] = useState<string[]>([]);
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  function handleCheck(keys, event?) {
    setCheckedKeys(keys);
    if (rest.onCheck) {
      rest.onCheck(keys, event);
    }
  }

  function handleExpand(expendedKeys) {
    setExpendedKeys(expendedKeys);
  }

  function handleTitleRender(node: TreeDataNode) {
    if (rest.titleRender) {
      return rest.titleRender(node);
    }
    return titleField ? node[titleField] : node.title;
  }

  function handleSelect(keys: string[], event) {
    if (keys.length > 0) {
      setSelectedKeys(keys);
      if (typeof rest.onSelect === "function") {
        rest.onSelect(keys.slice(0), event);
      }
    }
  }

  useEffect(() => {
    if (rest.treeData) {
      if (selectAll) {
        const keys = walkTree(rest.treeData, (node) => node.key);
        handleCheck(keys);
      } else {
        handleCheck([]);
      }
    }
  }, [selectAll, rest.treeData]);

  useEffect(() => {
    if (rest.treeData) {
      if (expandAll) {
        const keys = walkTree(rest.treeData, (node) => node.key);
        handleExpand(keys);
      } else {
        handleExpand([]);
      }
    }
  }, [expandAll, rest.treeData]);

  // 设置默认值选中keys
  useEffect(() => {
    if (rest.treeData) {
      handleCheck(rest.defaultCheckedKeys);
    }
  }, [rest.defaultCheckedKeys, rest.treeData]);

  useEffect(() => {
    if (rest.treeData && rest.defaultSelectedKeys?.length) {
      handleSelect(rest.defaultSelectedKeys as string[], null);
    }
  }, [rest.defaultSelectedKeys, rest.treeData]);

  useEffect(() => {
    // console.log("[default keys]", rest.defaultSelectedKeys);
  }, [rest.defaultSelectedKeys]);

  useEffect(() => {
    console.log("[tree data]");
  }, [rest.treeData]);

  return (
    <Tree
      {...rest}
      onCheck={handleCheck}
      onExpand={handleExpand}
      onSelect={handleSelect}
      expandedKeys={expandedKeys}
      checkedKeys={checkedKeys}
      selectedKeys={selectedKeys}
      icon={({ isLeaf }) => (
        <MenuIcon
          icon={isLeaf ? FileIcon : FolderIcon}
          style={{ fontSize: 16 }}
        />
      )}
      titleRender={handleTitleRender}
    >
      {children}
    </Tree>
  );
}

GWTree.TreeNode = Tree.TreeNode;

GWTree.ItemMenu = ItemMenu;
